import { useContext } from 'react';
import { useTranslation as useTranslation$1, I18nContext as I18nContext$1 } from 'react-i18next';
import { I18nContext as I18nContext$2 } from './podo/i18nNextContext.mjs';
import './podo/fetch-i18n-resources/FetchI18nResources.mjs';

const getRuntimeFramework = () => {
  if (typeof window !== "undefined" && window?.__NEXT_DATA__ === void 0) {
    return "podo";
  }
  return "next";
};
const I18nContext = getRuntimeFramework() === "next" ? I18nContext$1 : I18nContext$2;
function useI18n() {
  const { i18n } = useContext(I18nContext);
  return i18n;
}
function useLanguage() {
  const { i18n } = useContext(I18nContext);
  return i18n.language;
}
function useTranslation(i18nInstance) {
  return useTranslation$1(
    "translation",
    i18nInstance !== void 0 ? { i18n: i18nInstance } : void 0
  );
}

export { useI18n, useLanguage, useTranslation };
//# sourceMappingURL=hooks.mjs.map
